<template>
    <div class="contenedor">
      <AgencyImportExcludeDomains  :clientId="user.client_id" />
      <div class="card p-2" v-if="total > 0">
	      <h4>{{$t('lang.column.total')}}: {{total}}</h4>
	      <div class="mt-2 p-2">
	      	<small v-for="word in words" class="mr-2 badge badge-primary">{{word}}</small>
	      	<strong v-if="left > 0" class="mr-2 badge">{{$t('lang.ondemand.andmore',{cant:(left)})}} </strong>
          <span v-if="left > 0" @click="seemore()"  class="badge badge-success text-white mt-1 cursor-pointer p-2"><i class="icon-plus"></i> {{ $t('lang.notification.seemore') }}</span>
	      </div>
        <button @click="deleteWords()" class="btn btn-danger mt-2" v-if="total > 0 && false">{{$t('lang.notification.delete')}}</button>
  	  </div>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { clientsService } from "@/_services";
import AgencyImportExcludeDomains from "@/components/Agencies/AgencyImportExcludeDomains.vue";
export default {
    data() {
    return {
      words:[],
      page:0,
      total:0,
      left:0
    };
  },

  components: {
    AgencyImportExcludeDomains
  },
  
  computed: {

    user() {
      return this.$store.state.authentication.user;
    },
  },

  created(){
  	this.seemore()
  },

  methods:{
    seemore(){
      clientsService.getBlacklist(this.page).then((result) => {
        result.words.forEach((res) => {
            this.words.push(res)      
        })
        this.total = result.total
        this.left = result.left
        this.page++
      });

    },
  	deleteWords(){
      this.$swal({
          type: "warning",
          title: this.$t("lang.refuse.sure"),
          text: "",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33a2c",
          confirmButtonText: this.$t('lang.notification.delete'),
        }).then((result) => {
          if (result.value) {
            clientsService.deleteWords();
            this.$swal({
              type: "success",
              title: this.$t("lang.label.great"),
              text: this.$t("lang.label.passwordchangedsuccessfully"),
              showConfirmButton: false,
              timer: 1500,
            });
          }
        });
    }
  }

}
</script>